exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs[data-v-a3820fc2] {\n  font-size: 12px;\n  margin-bottom: -7px;\n}\n.title_local[data-v-a3820fc2] {\n  font-size: 18px;\n}\n.red-bg[data-v-a3820fc2] {\n  border-radius: 5px;\n  background-color: rgba(150, 8, 25, 0.6) !important;\n}\n.yellow-bg[data-v-a3820fc2] {\n  border-radius: 5px;\n  background-color: rgba(100, 102, 0, 0.6) !important;\n}\n.green-bg[data-v-a3820fc2] {\n  border-radius: 5px;\n  background-color: rgba(0, 53, 28, 0.6) !important;\n}", ""]);

// exports
